// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ggdoUfecI2swlY {
  display: flex;
  align-items: center;
  padding: 2px 0;
}
.m36ofSs3Uq6kfU {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -2px;
  margin-left: 8px;
  padding: 2px 6px;
  border-radius: 3px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-code, ui-monospace, 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Courier, monospace);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `ggdoUfecI2swlY`,
	"tooltipShortcut": `m36ofSs3Uq6kfU`
};
export default ___CSS_LOADER_EXPORT___;
